import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { register } from 'swiper/element/bundle';
import {config} from "devextreme/common";
import { licenseKey } from './devextreme-license';

// Swiper
register();
// add Devextreme licence
config({ licenseKey });

if (environment.production) {
  enableProdMode();
  if(environment['sentryDsn']) {
    Sentry.init({
      dsn: environment['sentryDsn'],
      environment: environment['sentryEnvironment'] || 'production',
      release: environment.appVersion,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
      ],
      sampleRate: 0.05,
      // Tracing
      tracesSampleRate: 0.05, //  Capture 100% of the transactions
      replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
}

function bootstrap() {
     platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
   };


 if (document.readyState === 'complete') {
   bootstrap();
 } else {
   document.addEventListener('DOMContentLoaded', bootstrap);
 }

export default bootstrap;
